import axiosAPI from './axiosAPI';

import {
    ApiSubscriptionPayResponse,
    ApiSubscriptionPaymentsResponse,
    ApiSubscriptionResponse,
    ApiInvoiceCreateResponse,
    ApiInvoiceListResponse,
} from '../models/ApiSubscription';

/**
 * API-методы для раздела «API» в ЛК (D-2).
 * База — axiosAPI (baseURL = apiAddress = .../api/lk, JWT из localStorage.token).
 */
export class ApiSubscriptionAPI {
    /**
     * GET /api/lk/api_subscription
     * Текущая подписка + активный тариф.
     */
    Get(): Promise<ApiSubscriptionResponse> {
        return new Promise((resolve, reject) => {
            axiosAPI
                .get('/api_subscription')
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    /**
     * POST /api/lk/api_subscription/pay
     * Создаёт платёж ЮKassa, возвращает confirmation_url для редиректа.
     */
    Pay(acceptOfferApi: boolean = false, months: number = 0): Promise<ApiSubscriptionPayResponse> {
        return new Promise((resolve, reject) => {
            axiosAPI
                .post('/api_subscription/pay', {
                    accept_offer_api: acceptOfferApi,
                    months,
                })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    /**
     * GET /api/lk/api_subscription/payments
     * История платежей пользователя (последние 20).
     */
    GetPayments(): Promise<ApiSubscriptionPaymentsResponse> {
        return new Promise((resolve, reject) => {
            axiosAPI
                .get('/api_subscription/payments')
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    /**
     * POST /api/lk/api_subscription/invoice
     * Выпускает счёт на оплату по банковскому переводу.
     */
    CreateInvoice(months: number): Promise<ApiInvoiceCreateResponse> {
        return new Promise((resolve, reject) => {
            axiosAPI
                .post('/api_subscription/invoice', { months })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    /**
     * GET /api/lk/api_subscription/invoices
     * История счетов пользователя.
     */
    ListInvoices(): Promise<ApiInvoiceListResponse> {
        return new Promise((resolve, reject) => {
            axiosAPI
                .get('/api_subscription/invoices')
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    /**
     * GET /api/lk/api_subscription/invoice/{id}.pdf — скачивает PDF через axios
     * (JWT в заголовке; прямая ссылка в новой вкладке токен не передаёт).
     */
    DownloadInvoice(id: number): Promise<Blob> {
        return new Promise((resolve, reject) => {
            axiosAPI
                .get(`/api_subscription/invoice/${id}`, { responseType: 'blob' })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }
}

export const apiSubscriptionAPI = new ApiSubscriptionAPI();
